import React, { useMemo } from 'react';
import Emoji from 'react-emoji-render';
import { last } from 'lodash';

import DayJs, { CONVERSATION_CALENDAR } from 'utils/Dayjs';

import Show from 'components/Show';
import Avatar from 'components/Misc/Avatar';
import { Title } from 'components/Misc/Typography';

import { useAppStore } from 'store/useAppStore';
import { useMessengerStore } from 'store/useMessengerStore';

const Conversation = ({ conversation }) => {
	// Use app's store
	const user = useAppStore(state => state.user);

	// Use messenger's store
	const onActive = useMessengerStore(state => state.onActive);

	// Store conversation's recipient
	const recipient = useMemo(() => conversation.participants?.find(p => p.id !== user.id) ?? {}, [conversation, user]);

	// Store last message
	const latest = useMemo(() => last(conversation.messages) ?? {}, [conversation]);

	// Store unread messages
	const unread = useMemo(() => conversation.messages?.filter(m => !m.readby.some(r => r.userId === user.id)) ?? [], [conversation, user]);

	// Handle conversation's selection
	const onConversation = () => onActive(conversation.id);

	return (
		<div className="py-1 px-2 flex items-center space-x-2 hover:bg-neutral-50 dark:hover:bg-neutral-700 rounded-lg cursor-pointer transition-colors" onClick={onConversation}>
			<Avatar
				small
				alt={recipient.fullName}
				src={recipient.avatar}
				online={recipient.online}
			/>

			<div className="flex flex-1 space-x-2 overflow-hidden">
				<div className="flex flex-col flex-1 justify-center overflow-hidden">
					<Title
						title={recipient.fullName}
					/>

					<Emoji
						text={latest?.message}
						className="leading-tight text-sm text-neutral-500 dark:text-neutral-400 whitespace-nowrap text-ellipsis overflow-hidden transition-colors"
					/>
				</div>

				<div className="pt-0.5 flex flex-col items-end justify-center">
					<Show if={unread?.length}>
						<div className="w-5 h-5 leading-5 bg-emerald-500 text-xs font-bold text-white rounded-full text-center animate-fade-in">
							{unread?.length > 9 ? '9+' : unread?.length}
						</div>
					</Show>
			
					<div className="pb-0.5 flex items-end flex-1 text-xs text-neutral-500 dark:text-neutral-400 transition-colors">
						{DayJs(latest?.createdAt).calendar(null, CONVERSATION_CALENDAR)}
					</div>
				</div>
			</div>
		</div>
	);
};

export default Conversation;
